import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarComponent } from '../../../common/sidebar/sidebar.component';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorCodeTableComponent } from '../../../tables/error-code/error-code-table/error-code-table.component';
import { ErrorCodeOverviewComponent } from '../error-code-overview/error-code-overview.component';

@Component({
  selector: 'app-error-code-recycling-overview',
  imports: [SidebarComponent, CommonModule, RouterModule, ErrorCodeTableComponent],
  templateUrl: './error-code-recycling-overview.component.html',
  styleUrl: './error-code-recycling-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DatePipe],
})
export class ErrorCodeRecyclingOverviewComponent extends ErrorCodeOverviewComponent implements OnInit, OnDestroy {
  constructor() {
    super();
    this.recyclingModeEnabled = true;
    this.sidebarConfiguration.reviewAreaEnabled = false;
    this.sidebarConfiguration.mergeReviewAreaEnabled = false;
  }

  protected override configureReviewsEnabled(): void {
    this.sidebarConfiguration.reviewAreaEnabled = false;
  }

  protected override configureMergeReviewsEnabled(): void {
    this.sidebarConfiguration.mergeReviewAreaEnabled = false;
  }
}
